export default {
  //
  "addBanner": "/backstageApi/background/banner/save",
  "updateBanner": "/backstageApi/background/banner/update",
  "deleteBannerById": "/backstageApi/background/banner/deleteById",
  "bannerList": "/backstageApi/background/banner/bannerList",
  "bannerOne": "/backstageApi/background/banner/selectOne",
  "getSwitchData": "/backstageApi/background/banner/getSwitchData",
  "updateMapValue": "/backstageApi/background/banner/updateMapValue",
  // 统计
  "selectBannerClickDataList": "/backstageApi/background/banner/selectBannerClickDataList",
  "selectBannerClickDataGroupByOS": "/backstageApi/background/banner/selectBannerClickDataGroupByOS",
  "selectBannerActionDataGroupByOS": "/backstageApi/background/banner/selectBannerActionDataGroupByOS",

}



// WEBPACK FOOTER //
// ./src/api/banner.js